// components/NotificationModal.jsx
import React from "react";
import { RiCloseFill } from "react-icons/ri";

const NotificationModal = ({ open, onClose, notification }) => {
    if (!open || !notification) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 relative animate-fadeIn"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold">Notification</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800"
                    >
                        <RiCloseFill size={24} />
                    </button>
                </div>

                {/* Modal Body */}
                <p className="text-gray-700 mb-4">{notification.description}</p>

                <div className="text-sm text-gray-400 mb-4">
                    Created At: {new Date(notification.createdAt).toLocaleString()}
                </div>

                {/* Modal Footer */}
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition"
                    >
                        Close
                    </button>
                </div>
            </div>

            {/* Animation Styles */}
            <style jsx>{`
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
        </div>
    );
};

export default NotificationModal;